import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AlarmOverview, Application } from '../../../interfaces/alarm';
import { Installation } from '../../../interfaces/facilty';
import { AppModel } from '@ams/dumbledore';
import { DataPointsResult } from '../../../interfaces/data-points';
import { MixitX509BannerComponent } from '../../mixit-x509-banner/mixit-x509-banner.component';
import { AsyncPipe } from '@angular/common';
import { AlarmBarComponent } from '../../alarms/alarm-bar/alarm-bar.component';
import { SchematicsTileComponent } from '../../schematics-tile/schematics-tile.component';
import { PressureSystemChartComponent } from '../../charts/pressure-system-chart/pressure-system-chart.component';

@Component({
    selector: 'app-pressure-system-dashboard',
    templateUrl: './pressure-system-dashboard.component.html',
    styleUrls: ['./pressure-system-dashboard.component.scss'],
    imports: [
    MixitX509BannerComponent,
    AlarmBarComponent,
    SchematicsTileComponent,
    PressureSystemChartComponent,
    AsyncPipe
]
})
export class PressureSystemDashboardComponent {
  @Input() public alarm$: Observable<AlarmOverview>;
  @Input() application: Application;
  @Input() public installation$: Observable<Installation>;
  @Input() public schematic$: Observable<AppModel>;
  @Input() public dataPoints$: Observable<DataPointsResult>;
}
